var n=function(n){var r=[],e=function(n){var t;n.defaultSelected?r.push(n.id):null===(t=n.children)||void 0===t||t.forEach((function(n){e(n)}))};return e(n),r};export{n as findDefaultSelectedDataItems};
